import { render, staticRenderFns } from "./LivePlayer.vue?vue&type=template&id=2079ff02&scoped=true&"
import script from "./LivePlayer.vue?vue&type=script&lang=ts&"
export * from "./LivePlayer.vue?vue&type=script&lang=ts&"
import style0 from "./LivePlayer.vue?vue&type=style&index=0&id=2079ff02&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2079ff02",
  null
  
)

export default component.exports